/** 
 * @module Authentication module. 
 *         All the interactions with users should start from this module
 * @requires system
 * @requires routeconfig
 */

define('services/appsecurity',['durandal/system', 'services/routeconfig', 'services/logger']
	, function (system, routeconfig, logger) {

	    var self = this;

	    // Get the Authorization header for include in requests
	    function getSecurityHeaders() {
	        var authenticationInfo = sessionStorage['ewra.authInfo'] || localStorage['ewra.authInfo'];

	        if (authenticationInfo) {
	            authenticationInfo = JSON.parse(authenticationInfo);
	            return { 'Authorization': 'Bearer ' + authenticationInfo.a, 'RT': authenticationInfo.r, 'Client': 'webApp' };
	        }

	        return {};
	    };
	    function getAuthenticationInfo() {
	        var authenticationInfo = sessionStorage['ewra.authInfo'] || localStorage['ewra.authInfo'];
	        if (authenticationInfo) {
	            return authenticationInfo;
	        }
	        return '';
	    };

	    // Clear stored access tokens from local and session storage
	    function clearAccessToken() {
	        localStorage.removeItem('ewra.authInfo');
	        sessionStorage.removeItem('ewra.authInfo');
	    };

	    // Cleanup location fragment
	    function cleanUpLocation() {
	        window.location.hash = '';

	        if (history && typeof (history.pushState) !== 'undefined') {
	            history.pushState('', document.title, location.pathname);
	        }
	    };

        function getUrlParameter(sParam) {
	        if (window.location.hash.split('#')[1] != undefined) {
	            var sURLVariables = window.location.hash.split('#')[1].split('&'),
                    sParameterName,
                    i;

	            for (i = 0; i < sURLVariables.length; i++) {
	                sParameterName = sURLVariables[i].split('=');

	                if (sParameterName[0] === sParam) {
	                    return sParameterName[1] === undefined ? true : sParameterName[1];
	                }
	            }
	        }
	    };

	    //Archive session storage to local
	    function archiveSessionStorageToLocalStorage() {
	        var backup = {};

	        for (var i = 0; i < sessionStorage.length; i++) {
	            backup[sessionStorage.key(i)] = sessionStorage[sessionStorage.key(i)];
	        }

	        localStorage['sessionStorageBackup'] = JSON.stringify(backup);
	        sessionStorage.clear();
	    };

	    // Restore session storage from local
	    function restoreSessionStorageFromLocalStorage() {
	        var backupText = localStorage['sessionStorageBackup'],
                backup;

	        if (backupText) {
	            backup = JSON.parse(backupText);

	            for (var key in backup) {
	                sessionStorage[key] = backup[key];
	            }

	            localStorage.removeItem('sessionStorageBackup');
	        }
	    };

	    //------------------------------Logic related to Fetching Current Year of Assessment Starts Here-----------------------------------------------------------------------------


	    function GetCurrentProfileOfAssessment()
	    {
	        var self = this;
	        try{
	            return $.ajax({
	                url: "/api/Account/GetCurrentprofileOfAssessment",
	                type: "GET",
	                headers: getSecurityHeaders()
	            }).success(function (result) {
                    if (result !== null) {
                        self.CurrentProfileOfAssessment(result.split('|')[0]);
                        self.CurrentProfileOfAssessmentId(result.split('|')[1]);
                    }
	            }).fail(function () {
	            });
	        }
	        catch(e)
	        {
	            var msg = 'Exception: ' + e + ' | Source:ajax call from GetCurrentProfileOfAssessment() method in appsecurity.js';
	        }
        }

        function GetCurrentLocaleOfUser() {
            var self = this;
            try {
                return $.ajax({
                    url: "/api/Account/GetCurrentLocaleOfUser",
                    type: "GET",
                    headers: getSecurityHeaders()
                }).success(function (result) {
                   
                    if (result !== null && result != "" && result != undefined) {
                        self.CurrentLocaleOfUser(result.split('|')[0]);
                        self.CurrentLocaletextOfUserLang(result.split('|')[1]);
                        if (result.split('|').length > 2)
                            self.CurrentLocaletextOfUser(result.split('|')[2]);
                       
                    }
                }).fail(function () {
                });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajax call from GetCurrentLocaleOfUser() method in appsecurity.js';
            }
        }

        function SaveCurrentLocale(localeId) {
            try {
                
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Account/SaveLocaleSettings?localeId=" + localeId,
                    type: "POST",
                    headers: headers,
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajax call from SaveSettings() method in GeneralSettings.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    
                    if (status == 'success') {
                        self.CurrentLocaletextOfUser(localeText);

                        //if (localeText != undefined && localeText != "") {
                        //    var langCode = localeText.substring(0, 2);
                        //    self.SelectedLanguageBadge(langCode);
                        //}

                        logger.logSuccess('Language changed successfully.', 'Success', true);

                        //var url = window.location.href,
                        //    suburl = url.substring(url.lastIndexOf('/') + 1);

                        //if (suburl == 'Landing' || suburl == 'Landing#')
                        //    location.reload(true);
                        //else {
                        //    router.navigate('Landing', true);
                        //    location.reload(true);
                        //}
                    }
                    else {
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(viewmodel), true);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source:ajaxSuccess method in SaveSttings() method in GeneralSettings.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    var msg = 'Exception: ' + error + ' | Source:ajaxFail method in SaveSttings() method in GeneralSettings.js';
                    logger.logMessage(msg);

                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source:ajaxFail method in SaveSttings() method in GeneralSettings.js';
                    logger.logMessage(msg);
                }
            }
        }


		function GetConfigurationFreezeFlag() {
			var self = this;
			try {
				return $.ajax({
					url: "/api/Configuration/GetConfigurationFreezeFlag",
					type: "GET",
					headers: getSecurityHeaders()
				}).success(function (result) {
					if (result !== null) {
						self.isConfigurationFreeze(result);
					}
				}).fail(function () {
				});
			}
			catch (e) {
				var msg = 'Exception: ' + e + ' | Source:ajax call from GetConfigurationFreezeFlag() method in appsecurity.js';
			}
		}

	    function GetCurrentYearOfAssessment() {
	        var self = this;
	        try {
	            return $.ajax({
	                url: "/api/Account/GetCurrentYearOfAssessment",
	                type: "GET",
	                headers: getSecurityHeaders()
	            }).success(function (result) {
	                if (result > 0)
	                    self.CurrentYearOfAssessment(result);
	            }).fail(function () {
	            });
	        } catch (e) {
	            var msg = 'Exception: ' + e + ' | Source:ajax call from GetCurrentYearOfAssessment() method in appsecurity.js';
	            //logger.logMessage(msg);
	        }
	    }
	    function GetAssessmentName(Id)
	    {
	        var self = this;
	        for (var i = 0; i < self.AssessmentTypes().length;i++)
	            if (self.AssessmentTypes()[i].AssessmentId == Id)
	        {
	                var AssessmentName = self.AssessmentTypes()[i].AssessmentName;
	            return AssessmentName;
	          
	        }
	    }
	    function GetAssessmentNames()
	    {
	        try {
	            var self = this;
	            return $.ajax({
	                url: "/api/Configuration/GetAssessmentTypes",
	                type: "GET",
	                headers: getSecurityHeaders()
	            }).success(function (result) {
	                if (result.length > 0)
	                    self.AssessmentTypes(result);
	            }).fail(function () {
	            });
	        }
	        catch(e)
	        {
	            var msg = 'Exception: ' + e + ' | Source:ajax call from GetAssessmentName() method in appsecurity.js';
	        }
	    }
	    //------------------------------Logic related to Fetching Current Year of Assessment Ends Here-------------------------------------------------------------------------------
	    function getYearOfAssessmentDetails() {
	        try {
	            var self = this;
	            return $.ajax({
	                url: "/api/Calculation/GetProfileofAssessmentData",
	                type: "GET",
	                headers: getSecurityHeaders()
	            })
                .success(function (jsonResult, status) {
                    if (jsonResult.length > 0) {
                        for (var i = 0; i < jsonResult.length; i++) {
                            if (self.CurrentYearOfAssessment() == jsonResult[i].YearofAssessment) {
                                self.isConfigurationFreeze(jsonResult[i].ConfigurationFreezeFlag);
                                break;
                            }
                        }
                        return;
                    }
                    else
                        logger.logError('Error while Fetching Current Year of Assessment. Please contact your Administrator', 'Error', system.getModuleId(appSecurity), true);
                })
                .fail(function (error) {
                    var msg = 'Exception: ' + error + ' | Source: ajaxSuccess from getYearOfAssessmentDetails() method in appsecurity.js';
                    logger.logMessage(msg);
                });
	        }
	        catch (e) {
	            var msg = 'Exception: ' + e + ' | Source: getYearOfAssessmentDetails() method in appsecurity.js';
	            logger.logMessage(msg);
	        }
	    }
	 
	    // Class representing user information
		function UserInfoViewModel(userName, primaryRoleID, primaryRoleName, secondaryRoleID, secondaryRoleName, moduleList, fullName, firstName, lastName, persistent, ProjectCount, Phonenumberverified, TwofactorEnabled, EmailId, PhoneNumber) {
	        this.userName = ko.observable(userName);
	        this.PrimaryRoleId = ko.observable(primaryRoleID);
	        this.PrimaryRoleName = ko.observable($('<div/>').html(primaryRoleName).text());
	        this.SecondaryRoleId = ko.observable(secondaryRoleID);
	        this.SecondaryRoleName = ko.observable($('<div/>').html(secondaryRoleName).text());
	        this.fullName = ko.observable(fullName);
	        this.persistent = ko.observable(persistent);
	        this.ProjectCount = ko.observable(ProjectCount);
	        this.TwofactorEnabled=ko.observable(TwofactorEnabled);
	        this.Phonenumberverified = ko.observable(Phonenumberverified),
	        this.firstName = ko.observable(firstName);
            this.lastName = ko.observable(lastName);
			this.EmailId = ko.observable(EmailId);
			this.PhoneNumber = ko.observable(PhoneNumber);
	        this.moduleList = ko.observable($.map(moduleList, function (item) {
	            return new moduleModel(item);
	        }));
	    };
	    function moduleModel(item) {
	        try {
	            var self = this;
	            self.ModuleId = ko.observable(item.ModuleId);
	            self.ModuleCodeName = ko.observable(item.ModuleCodeName);
	            self.ModuleDisplayName = ko.observable(item.ModuleDisplayName);
	            self.ActiveIndicator = ko.observable(item.ActiveIndicator);
	            var mappedPageList = $.map(item.PageList, function (result) {
	                return new PageModel(result);
	            });
	            self.PageList = ko.observableArray(mappedPageList);
	        }
	        catch (e) {
	            var msg = 'Exception: ' + e + ' | Source: ModuleModel() method in appsecurity.js';
	            logger.logMessage(msg);
	        }
	    };

	    function RefreshTokenSession()  
	    {
            try {
               
                var self = this;
                var sessionVariable = sessionStorage['ewra.authInfo'];

                if (sessionVariable === undefined)
                    sessionVariable = localStorage['ewra.authInfo'];

	            this.login({
	                grant_type: 'refresh_token',
                    refresh_token: JSON.parse(sessionVariable).r,
	                client_id: 'webApp'
	            }).done(function (data) {
	                self.setAuthenticationInfo(data.access_token, data.refresh_token, data['.expires'], false);
	                self.CountDownTime(data['.expires']);
	                self.Counter(0);
	                self.refreshAFToken().done(function (data) {
	                    $("input[name='__RequestVerificationToken']").val(data);
	                });
	            }).error(function (error) {
	            });
	        }
	        catch(e)
	        {
                var msg = 'Exception: ' + e + ' | Source: ModuleModel() method in appsecurity.js';
                logger.logMessage(msg);
               
	        }
	    }

	    function PageModel(item) {
	        try {
	            var self = this;
	            self.FolderName = ko.observable(item.FolderName);
	            self.PageId = ko.observable(item.PageId);
	            self.PageCodeName = ko.observable(item.PageCodeName);
	            self.PageDisplayName = ko.observable(item.PageDisplayName);
	            self.ActiveIndicator = ko.observable(item.ActiveIndicator);
	            self.ReadAccess = ko.observable(item.ReadAccess);
	            self.WriteAccess = ko.observable(item.WriteAccess);
	        }
	        catch (e) {
	            var msg = 'Exception: ' + e + ' | Source: PageModel() method in appsecurity.js';
	            logger.logMessage(msg);
	        }
	    };
	    function getParameterByName(name, url) {
	        if (!url) url = window.location.href;
	        name = name.replace(/[\[\]]/g, "\\$&");
	        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
	        if (!results) return null;
	        if (!results[2]) return '';
	        return decodeURIComponent(results[2].replace(/\+/g, " "));
		}
		function GetAppSetting() {
			try {
				return $.ajax({
					url: "/api/Account/GetAppSetting",
					type: "GET",
					headers: getSecurityHeaders()
				}).success(function (result) {
					if (result !== null && result !== "") {
						return result;
					}
				}).fail(function () {
				});
			}
			catch (e) {
				var msg = 'Exception: ' + e + ' | Source:ajax call from GetCurrentProfileOfAssessment() method in appsecurity.js';
			}
		}
        //function GetLocalizationDetailsResx(locale) {
        //    try {
        //        var self = this;
        //        return $.ajax({
        //            url: "/api/Configuration/GetLocalizationDetailsResx?LocaleCulture=" + locale,
        //            type: "GET",
        //            headers: getSecurityHeaders()
        //        })
        //            .success(ajaxSuccess)
        //            .fail(ajaxFail);
        //    }
        //    catch (e) {
        //        var msg = 'Exception: ' + e + ' | Source: GetLocalizationDetailsResx() method in LocalizationModule.js';
        //        logger.logMessage(msg);
        //    }
        //    function ajaxSuccess(jsonResult, status) {
        //        try {

        //            if (jsonResult.length == 0)
        //                logger.logMessage('No records present for localized details.', 'Warning', system.getModuleId(vm), true);

        //            for (var i = 0; i < jsonResult.length; i++) {
        //                self.LocalizedIndexList().push(jsonResult[i].Identifier);
        //            }

        //            var MappedGroupDetails = $.map(jsonResult, function (result) {
        //                return new LocalizationModel(result);
        //            });

        //            self.LocalizedTextList(MappedGroupDetails);
        //            if (self.LocalizedTextList() == undefined || self.LocalizedTextList() == null || self.LocalizedTextList().length <= 0 || self.LocalizedIndexList() == undefined || self.LocalizedIndexList() == null)
        //                self.LocaleCheckFlag(false);
        //            else
        //                self.LocaleCheckFlag(true);

        //            //self.appsecurity.LocaleCheckFlag(self.LocaleCheckFlag());
        //            //self.appsecurity.LocalizedTextList(self.LocalizedTextList());
        //            //self.appsecurity.LocalizedIndexList(self.LocalizedIndexList());
        //            //self.ObjGeneralSettings.LocaleCheckFlag(self.LocaleCheckFlag());
        //            //self.ObjGeneralSettings.LocalizedTextList(self.LocalizedTextList());
        //            //self.ObjGeneralSettings.LocalizedIndexList(self.LocalizedIndexList());
        //        }
        //        catch (e) {
        //            var msg = 'Exception: ' + e + ' | Source: ajaxSuccess from GetLocalizationDetailsResx() method in login.js';
        //            logger.logMessage(msg);
        //        }
        //    }

        //    function ajaxFail(error, status) {
        //        try {
        //            if (error.status == 401) {
        //                app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
        //                    .then(function (option) {
        //                        if (option == "OK")
        //                            navigation.unauthorized();
        //                    })
        //            }
        //            else {
        //                var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetLocalizedData() method in LocalizationModule.js';
        //                logger.logMessage(msg);
        //            }
        //        }
        //        catch (e) {
        //            var msg = 'Exception: ' + e + ' | Source: ajaxFail from GetLocalizationDetailsResx() method in login.js';
        //            logger.logMessage(msg);
        //        }
        //    }
        //}
        //function LocalizationModel(item) {
        //    try {
        //        var self = this;
        //        self.Name = ko.observable($('<div/>').html(item.Name).text());
        //        self.NameIdentifier = ko.observable($('<div/>').html(item.Identifier).text());
        //    }
        //    catch (e) {
        //        var msg = 'Exception: ' + e + ' | Source: LocalizationModel() method in login.js';
        //        logger.logMessage(msg);
        //    }
        //}
	    return {
	        CurrentYearOfAssessment: ko.observable(undefined),
            CurrentProfileOfAssessment: ko.observable(undefined),
            CurrentProfileOfAssessmentId: ko.observable(undefined),
	        GetCurrentYearOfAssessment: GetCurrentYearOfAssessment,
	        GetCurrentProfileOfAssessment:GetCurrentProfileOfAssessment,
            getYearOfAssessmentDetails: getYearOfAssessmentDetails,
            GetCurrentLocaleOfUser: GetCurrentLocaleOfUser,
			GetConfigurationFreezeFlag: GetConfigurationFreezeFlag,
	        GetAssessmentName: GetAssessmentName,
	        RefreshTokenSession:RefreshTokenSession,
	        GetAssessmentNames:GetAssessmentNames,
            AssessmentTypes:ko.observableArray(),
	        getParameterByName:getParameterByName,
	        isConfigurationFreeze: ko.observable(),
	        CurrentPageName: ko.observable(),
	        ModuleList: ko.observable(),
	        ProjectCount: ko.observable(),
            Timer:ko.observable(),
            CountDownTime: ko.observable(),
            Counter:ko.observable(),
            TwofactorEnabled:ko.observable(),
	        PageList: ko.observable(),
	        Phonenumberverified:ko.observable(),
	        FolderList: ko.observable(),
	        ConfigurationAccess: ko.observable(),
	        ReadAccess: ko.observable(),
	        WriteAccess: ko.observable(),
	        ChangeperiodofAssessmentFlag: ko.observable(),
	        /** property {object} userInfo - The user object */
	        userInfo: ko.observable(),
	        ActionPageType: ko.observable(),
	        ActionFlagType: ko.observable(),
	        ActionPlanId: ko.observable(),
	        ActionPlanLabel: ko.observable(),
	        ActionPlanRoleId: ko.observable(),            
            SocializationReadOnly: ko.observable(false),
            IsSurTrackingToSurResponsePageNav: ko.observable(false),
            EmailId: ko.observable(),
            MFAat: ko.observable(),
            MFArt: ko.observable(),
            rMe: ko.observable(),
            expMFA: ko.observable(),
            UserContent: ko.observable(''),
            ContanctUs: ko.observable(''),
            CurrentLocaleOfUser: ko.observable(''),
            CurrentLocaletextOfUser: ko.observable(''),
           // SelectedLanguageBadge: ko.observable(''),

            CurrentLocaletextOfUserLang: ko.observable(''),
            CurrentLocaleOfUserFromLogin: ko.observable('en-US'),
            CurrentLocaleOfUserFromLoginId: ko.observable('1'),
            SaveCurrentLocale: SaveCurrentLocale,
            LocalePermissionFlag: ko.observable(true),

            LocaleCheckFlag: ko.observable(false),
            LocalizedTextList: ko.observableArray([]),
			LocalizedIndexList: ko.observableArray([]),
			IsExternalLogin: ko.observable(false),
			IsSSOUserFlag: ko.observable(),
			GetAppSetting: GetAppSetting,
			PhoneNumber: ko.observable(''),
	        /**
             * Set the authentication info. Look in storage for stored info
             * param {string} userName
             * param {Array} roles
             * param {long} userID
             * param {string} fullName
             * param {Array} instances
             * param {string} accessToken
             * param {string} accessToken
             * param {datetime} accessTokenExpiration
             * param {bool} persistent
             */
			setUserInfo: function (userName, primaryRoleID, primaryRoleName, secondaryRoleID, secondaryRoleName, moduleList, fullName, firstName, lastName, persistent, ProjectCount, Phonenumberverified, TwofactorEnabled, EmailId, PhoneNumber) {
	            var self = this;
				self.userInfo(new UserInfoViewModel(userName, primaryRoleID, primaryRoleName, secondaryRoleID, secondaryRoleName, moduleList, fullName, firstName, lastName, persistent, ProjectCount, Phonenumberverified, TwofactorEnabled, EmailId, PhoneNumber));
	        },

	        // Set authentication info in local or session storage
	        setAuthenticationInfo: function (accessToken, refreshToken, accessTokenExpiration, persistent) {
	            // Replace GMT with +0000 to make date conversion easy with momentjs
	            if (persistent) {
	                localStorage['ewra.authInfo'] = ko.toJSON({ a: accessToken, r: refreshToken, ex: accessTokenExpiration.replace('GMT', '+0000') });
	            } else {
	                sessionStorage['ewra.authInfo'] = ko.toJSON({ a: accessToken, r: refreshToken, ex: accessTokenExpiration.replace('GMT', '+0000') });
	            }
	        },

	        /**
             * Remove authentication info
             */
	        clearAuthInfo: function () {
	            var self = this;

	            clearAccessToken();
	            self.userInfo(undefined);
	        },

	        /**
             * Check if the authenticated user belongs to the role
             * param {Array} roles
             */
	        isUserInRole: function (roles) {
	            var self = this,
                    isuserinrole = false;

	            $.each(roles, function (key, value) {
	                // If authorized for all roles [*], just check if user is authenticated and has at least one role
	                if (value != '*') {
	                    if (self.userInfo().roles.indexOf(value) !== -1) {
	                        isuserinrole = true;
	                    }
	                }
	                else {
	                    isuserinrole = !(typeof (self.userInfo()) == 'undefined') && (self.userInfo().roles().length > 0);
	                }
	            });

	            return isuserinrole;
	        },

	        /**
             * Check if the authenticated user belongs to the role
             * param {Array} roles
             * param {Array} availableRoles
             */
	        isUserInGivenRoles: function (roles, availableRoles) {
	            var self = this,
                    isuserinrole = false;

	            $.each(roles, function (key, value) {
	                // If authorized for all roles [*], just check if user is authenticated and has at least one role
	                if (value != '*') {
	                    if (availableRoles.indexOf(value) !== -1) {
	                        isuserinrole = true;
	                    }
	                }
	                else {
	                    isuserinrole = (availableRoles.length > 0);
	                }
	            });

	            return isuserinrole;
	        },

	        /**
             * Get the security headers for sending authenticated ajax requests to the server
             */
	        getSecurityHeaders: getSecurityHeaders,

	        // Gets the Authentication Info
	        getAuthenticationInfo: getAuthenticationInfo,
	        /**
             * Helper method for storing authentication info in the Local Storage
             */
	        archiveSessionStorageToLocalStorage: archiveSessionStorageToLocalStorage,

	        returnUrl: routeconfig.siteUrl,

	        /**
             * Add external Login
             * param {object} data - External login info
             */
	        addExternalLogin: function (data) {
	            return $.ajax(routeconfig.addExternalLoginUrl, {
	                type: 'POST',
	                data: data,
	                headers: getSecurityHeaders()
	            });
	        },

	        /**
             * Get authenticated user info
             * param {object} accessToken
             */
	        getUserInfo: function (accessToken) {
	            var self = this,
                    headers;

	            if (typeof (accessToken) !== 'undefined') {
	                headers = {
	                    'Authorization': 'Bearer ' + accessToken
	                };
	            } else {
	                headers = getSecurityHeaders();
	            }

	            return $.ajax(routeconfig.userInfoUrl, {
	                cache: false,
	                headers: headers,
	                data: { Flag: 1 }
	            });
			},

			getAzureUserInfo: function (Token) {

				var authenticationInfo = sessionStorage['ewra.authInfo'] || localStorage['ewra.authInfo'];
				var headers = getSecurityHeaders();
				if (authenticationInfo) {
					authenticationInfo = JSON.parse(authenticationInfo);
					headers = { 'Token': Token,'Authorization': 'Bearer ' + authenticationInfo.a, 'RT': authenticationInfo.r, 'Client': 'webApp' };
				}

				return $.ajax(routeconfig.AzureUserInfo, {
					cache: false,
					headers: headers,
					data: { Flag: 1 }
					
				});
			},

	        /**
             * Register new user
             * param {object} data - Registration info
             */
	        register: function (data) {
	            var csrfToken = $("input[name='__RequestVerificationToken']").val();
	            var headers = getSecurityHeaders();
	            headers.__RequestVerificationToken = csrfToken;
	            return $.ajax(routeconfig.registerUrl, {
	                type: "POST",
	                data: data,
	                headers: headers
	            });
	        },
	        /**
             * Login the user
             * param {object} data - Login info
             */
	        login: function (data) {
	            return $.ajax(routeconfig.loginUrl, {
	                type: 'POST',
	                data: data
	            });
	        },

	        /**
             * Logout the user
             */
			logout: function () {
				if (this.IsExternalLogin() && this.IsSSOUserFlag() == 2) {
					//AD User
					this.clearAuthInfo();
					GetAppSetting().done(function (data) {
						$('#sessionTimer').modal('hide');
						window.location.href = "https://login.microsoftonline.com/common/oauth2/v2.0/logout?post_logout_redirect_uri=" + data;
					});
				} else {
					// SSO and Normal User
					var csrfToken = $("input[name='__RequestVerificationToken']").val();
					var headers = getSecurityHeaders();
					headers.__RequestVerificationToken = csrfToken;
					return $.ajax(routeconfig.logoutUrl, {
						type: 'POST',
						headers: headers
					});
				}
			},


	        /**
             * Forgot your password
             */
	        forgotPassword: function (data) {
	            return $.ajax(routeconfig.forgotPassword, {
	                type: 'POST',
	                data: data,
	                cache: false,
	                headers: data.headers
	            });
	        },

	        /**
             * Reset your password
             */
	        resetPassword: function (data) {
	            return $.ajax(routeconfig.resetPassword, {
	                type: 'POST',
	                data: data,
	                cache: false,
	                headers: data.headers
	            });
	        },

	        /**
             * Always call this method when initializing the application for getting authenticated user info (from storage)
             * or redirect when returning from a provider or associating another login
             */
			initializeAuth: function () {
				var self = this;
				return system.defer(function (dfd) {
					restoreSessionStorageFromLocalStorage();

					var accessToken = getUrlParameter('access_token');
					if (accessToken != undefined && accessToken != null) {
						var accessTokenExpiration = getUrlParameter('expires_in');
						var refreshToken = getUrlParameter('refresh_token');
						localStorage['ewra.authInfo'] = JSON.stringify({ a: accessToken, r: refreshToken, ex: accessTokenExpiration });
					}
					var idToken = getUrlParameter('id_token')
					if (idToken != undefined && idToken != null) {
						if ($(location).attr('href').search('access_token') > 0) {
							self.getAzureUserInfo(idToken).done(function (data) {
								var accessToken = data.access_token;
								if (accessToken != undefined && accessToken != null) {
									var accessTokenExpiration = data.expires_in;
									var refreshToken = data.refresh_token;
									localStorage['ewra.authInfo'] = JSON.stringify({ a: accessToken, r: refreshToken, ex: accessTokenExpiration });
									//}
									//if (sessionStorage['ewra.authInfo'] || localStorage['ewra.authInfo']) {
									self.getUserInfo()
										.done(function (data) {
											if (data.userName) {
												var persistent = (localStorage['ewra.authInfo'] || localStorage['ewra.authInfo']) != null;
												var now = new Date().getTime();
												if (sessionStorage['ewra.authInfo'] != null) {
													self.CountDownTime(JSON.parse(sessionStorage['ewra.authInfo']).ex)
												} else {
													//self.CountDownTime(JSON.parse(localStorage['ewra.authInfo']).ex)
													self.CountDownTime(JSON.parse(localStorage['ewra.authInfo']).ex.replace(/%20/g, ' ') + "+0000")
												}

												self.TwofactorEnabled(data.TwoFactorEnabled);
												var moduleList = JSON.parse(data.moduleList);
												self.setUserInfo(data.userName, data.primaryRoleID, data.primaryRoleName, data.secondaryRoleID, data.secondaryRoleName, moduleList, data.fullName, data.firstName, data.lastName, persistent, data.ProjectCount, data.PhoneNumber);
												var MappedModuleList = "";
												var MappedPageList = "";
												var MappedFolderList = "";
												for (var i = 0; i < moduleList.length; i++) {
													MappedModuleList += moduleList[i].ModuleCodeName + ";";
													for (var j = 0; j < moduleList[i].PageList.length; j++) {
														MappedPageList += moduleList[i].PageList[j].PageCodeName + ";";
														MappedFolderList += moduleList[i].PageList[j].FolderName + ";";
													}
												}
												self.ModuleList(MappedModuleList);
												self.PageList(MappedPageList);
												self.FolderList(MappedFolderList);
												self.ConfigurationAccess(false);
												self.PhoneNumber(data.PhoneNumber);
												if (data.userLocale !== null && data.userLocale != "" && data.userLocale != undefined) {
													self.CurrentLocaleOfUser(data.userLocale.split('|')[0]);
													self.CurrentLocaletextOfUserLang(data.userLocale.split('|')[1]);
													if (data.userLocale.split('|').length > 2) {
														self.CurrentLocaletextOfUser(data.userLocale.split('|')[2]);
														// GetLocalizationDetailsResx(data.userLocale.split('|')[2]);
													}
												}

												if ((self.PageList() != undefined) && (self.PageList().indexOf('ConfigurationFreeze') >= 0)) {
													for (var i = 0; i < self.userInfo().moduleList().length; i++) {
														for (var j = 0; j < self.userInfo().moduleList()[i].PageList().length; j++) {
															if (self.userInfo().moduleList()[i].PageList()[j].PageCodeName() == "ConfigurationFreeze" && (self.userInfo().moduleList()[i].PageList()[j].WriteAccess() == 'true' || self.userInfo().moduleList()[i].PageList()[j].WriteAccess()))
																self.ConfigurationAccess(true);
														}
													}
												}
												else
													self.ConfigurationAccess(false);
												self.refreshAFToken().done(function (data) {
													$("input[name='__RequestVerificationToken']").val(data);
												});

												self.EmailId(data.email);
											}
											dfd.resolve(true);

										})
										.fail(function () {
											dfd.resolve(true);
										});
								}
							}).fail(function () {
								dfd.resolve(true);
							});
						}
					}
					else if (sessionStorage['ewra.authInfo'] || localStorage['ewra.authInfo']) {
						self.getUserInfo()
							.done(function (data) {
								if (data.userName) {
									var persistent = (localStorage['ewra.authInfo'] || localStorage['ewra.authInfo']) != null;
									var now = new Date().getTime();
									if (sessionStorage['ewra.authInfo'] != null) {
										self.CountDownTime(JSON.parse(sessionStorage['ewra.authInfo']).ex)
									} else {
										//self.CountDownTime(JSON.parse(localStorage['ewra.authInfo']).ex)
										self.CountDownTime(JSON.parse(localStorage['ewra.authInfo']).ex.replace(/%20/g, ' ') + "+0000")
									}

									self.TwofactorEnabled(data.TwoFactorEnabled);
									var moduleList = JSON.parse(data.moduleList);
									self.setUserInfo(data.userName, data.primaryRoleID, data.primaryRoleName, data.secondaryRoleID, data.secondaryRoleName, moduleList, data.fullName, data.firstName, data.lastName, persistent, data.ProjectCount, data.PhoneNumber);
									var MappedModuleList = "";
									var MappedPageList = "";
									var MappedFolderList = "";
									for (var i = 0; i < moduleList.length; i++) {
										MappedModuleList += moduleList[i].ModuleCodeName + ";";
										for (var j = 0; j < moduleList[i].PageList.length; j++) {
											MappedPageList += moduleList[i].PageList[j].PageCodeName + ";";
											MappedFolderList += moduleList[i].PageList[j].FolderName + ";";
										}
									}
									self.ModuleList(MappedModuleList);
									self.PageList(MappedPageList);
									self.FolderList(MappedFolderList);
									self.ConfigurationAccess(false);
									self.PhoneNumber(data.PhoneNumber);

									if (data.userLocale !== null && data.userLocale != "" && data.userLocale != undefined) {
										self.CurrentLocaleOfUser(data.userLocale.split('|')[0]);
										self.CurrentLocaletextOfUserLang(data.userLocale.split('|')[1]);
										if (data.userLocale.split('|').length > 2) {
											self.CurrentLocaletextOfUser(data.userLocale.split('|')[2]);
											// GetLocalizationDetailsResx(data.userLocale.split('|')[2]);
										}
									}

									if ((self.PageList() != undefined) && (self.PageList().indexOf('ConfigurationFreeze') >= 0)) {
										for (var i = 0; i < self.userInfo().moduleList().length; i++) {
											for (var j = 0; j < self.userInfo().moduleList()[i].PageList().length; j++) {
												if (self.userInfo().moduleList()[i].PageList()[j].PageCodeName() == "ConfigurationFreeze" && (self.userInfo().moduleList()[i].PageList()[j].WriteAccess() == 'true' || self.userInfo().moduleList()[i].PageList()[j].WriteAccess()))
													self.ConfigurationAccess(true);
											}
										}
									}
									else
										self.ConfigurationAccess(false);
									self.refreshAFToken().done(function (data) {
										$("input[name='__RequestVerificationToken']").val(data);
									});

									self.EmailId(data.email);
								}
								dfd.resolve(true);
							})
							.fail(function () {
								dfd.resolve(true);
							});
					} else {
						dfd.resolve(true);
					}
				}).promise();
			},

	        refreshAFToken: function () {
	            return $.ajax(routeconfig.refreshaftoken, {
	                type: "GET",
	                cache: false,
	                headers: getSecurityHeaders()
	            });
	        },



	    };
	});

